export type IconsId =
  | 'add'
  | 'angle-right'
  | 'arrow_down'
  | 'arrow_rise'
  | 'arrows-rotate'
  | 'asssessment'
  | 'bell'
  | 'calendar'
  | 'chartbar'
  | 'check'
  | 'checkmark'
  | 'chip'
  | 'circle-question-solid'
  | 'clipboard-check-broken'
  | 'clipboard-check'
  | 'clipboard'
  | 'clock'
  | 'close'
  | 'copy'
  | 'dash'
  | 'database-backup'
  | 'database-plus'
  | 'delete'
  | 'docs'
  | 'dots'
  | 'download'
  | 'edit'
  | 'ellipsis-vertical'
  | 'ellipsis'
  | 'euro-sign-solid'
  | 'exclamation-triangle'
  | 'exclamation'
  | 'expand'
  | 'eye-close'
  | 'eye'
  | 'file_generate'
  | 'file'
  | 'filters'
  | 'info'
  | 'link'
  | 'list-check-solid'
  | 'list-dark'
  | 'lock'
  | 'log'
  | 'logout'
  | 'model_icon'
  | 'open'
  | 'pin'
  | 'question-mark'
  | 'question'
  | 'recreate'
  | 'risk_icon'
  | 'scales'
  | 'search-file-icon'
  | 'settings'
  | 'sidebar-right-icon'
  | 'sparkles'
  | 'trendlines'
  | 'triangle-exclamation'
  | 'upload_import'
  | 'upload'
  | 'usecase_icon'
  | 'user-solid'
  | 'view_table'
  | 'view_tags'
  | 'wallet'
  | 'xicon';

export type IconsKey =
  | 'Add'
  | 'AngleRight'
  | 'ArrowDown'
  | 'ArrowRise'
  | 'ArrowsRotate'
  | 'Asssessment'
  | 'Bell'
  | 'Calendar'
  | 'Chartbar'
  | 'Check'
  | 'Checkmark'
  | 'Chip'
  | 'CircleQuestionSolid'
  | 'ClipboardCheckBroken'
  | 'ClipboardCheck'
  | 'Clipboard'
  | 'Clock'
  | 'Close'
  | 'Copy'
  | 'Dash'
  | 'DatabaseBackup'
  | 'DatabasePlus'
  | 'Delete'
  | 'Docs'
  | 'Dots'
  | 'Download'
  | 'Edit'
  | 'EllipsisVertical'
  | 'Ellipsis'
  | 'EuroSignSolid'
  | 'ExclamationTriangle'
  | 'Exclamation'
  | 'Expand'
  | 'EyeClose'
  | 'Eye'
  | 'FileGenerate'
  | 'File'
  | 'Filters'
  | 'Info'
  | 'Link'
  | 'ListCheckSolid'
  | 'ListDark'
  | 'Lock'
  | 'Log'
  | 'Logout'
  | 'ModelIcon'
  | 'Open'
  | 'Pin'
  | 'QuestionMark'
  | 'Question'
  | 'Recreate'
  | 'RiskIcon'
  | 'Scales'
  | 'SearchFileIcon'
  | 'Settings'
  | 'SidebarRightIcon'
  | 'Sparkles'
  | 'Trendlines'
  | 'TriangleExclamation'
  | 'UploadImport'
  | 'Upload'
  | 'UsecaseIcon'
  | 'UserSolid'
  | 'ViewTable'
  | 'ViewTags'
  | 'Wallet'
  | 'Xicon';

export enum Icons {
  Add = 'add',
  AngleRight = 'angle-right',
  ArrowDown = 'arrow_down',
  ArrowRise = 'arrow_rise',
  ArrowsRotate = 'arrows-rotate',
  Asssessment = 'asssessment',
  Bell = 'bell',
  Calendar = 'calendar',
  Chartbar = 'chartbar',
  Check = 'check',
  Checkmark = 'checkmark',
  Chip = 'chip',
  CircleQuestionSolid = 'circle-question-solid',
  ClipboardCheckBroken = 'clipboard-check-broken',
  ClipboardCheck = 'clipboard-check',
  Clipboard = 'clipboard',
  Clock = 'clock',
  Close = 'close',
  Copy = 'copy',
  Dash = 'dash',
  DatabaseBackup = 'database-backup',
  DatabasePlus = 'database-plus',
  Delete = 'delete',
  Docs = 'docs',
  Dots = 'dots',
  Download = 'download',
  Edit = 'edit',
  EllipsisVertical = 'ellipsis-vertical',
  Ellipsis = 'ellipsis',
  EuroSignSolid = 'euro-sign-solid',
  ExclamationTriangle = 'exclamation-triangle',
  Exclamation = 'exclamation',
  Expand = 'expand',
  EyeClose = 'eye-close',
  Eye = 'eye',
  FileGenerate = 'file_generate',
  File = 'file',
  Filters = 'filters',
  Info = 'info',
  Link = 'link',
  ListCheckSolid = 'list-check-solid',
  ListDark = 'list-dark',
  Lock = 'lock',
  Log = 'log',
  Logout = 'logout',
  ModelIcon = 'model_icon',
  Open = 'open',
  Pin = 'pin',
  QuestionMark = 'question-mark',
  Question = 'question',
  Recreate = 'recreate',
  RiskIcon = 'risk_icon',
  Scales = 'scales',
  SearchFileIcon = 'search-file-icon',
  Settings = 'settings',
  SidebarRightIcon = 'sidebar-right-icon',
  Sparkles = 'sparkles',
  Trendlines = 'trendlines',
  TriangleExclamation = 'triangle-exclamation',
  UploadImport = 'upload_import',
  Upload = 'upload',
  UsecaseIcon = 'usecase_icon',
  UserSolid = 'user-solid',
  ViewTable = 'view_table',
  ViewTags = 'view_tags',
  Wallet = 'wallet',
  Xicon = 'xicon',
}

export const ICONS_CODEPOINTS: { [key in Icons]: string } = {
  [Icons.Add]: '61697',
  [Icons.AngleRight]: '61698',
  [Icons.ArrowDown]: '61699',
  [Icons.ArrowRise]: '61700',
  [Icons.ArrowsRotate]: '61701',
  [Icons.Asssessment]: '61702',
  [Icons.Bell]: '61703',
  [Icons.Calendar]: '61704',
  [Icons.Chartbar]: '61705',
  [Icons.Check]: '61706',
  [Icons.Checkmark]: '61707',
  [Icons.Chip]: '61708',
  [Icons.CircleQuestionSolid]: '61709',
  [Icons.ClipboardCheckBroken]: '61710',
  [Icons.ClipboardCheck]: '61711',
  [Icons.Clipboard]: '61712',
  [Icons.Clock]: '61713',
  [Icons.Close]: '61714',
  [Icons.Copy]: '61715',
  [Icons.Dash]: '61716',
  [Icons.DatabaseBackup]: '61717',
  [Icons.DatabasePlus]: '61718',
  [Icons.Delete]: '61719',
  [Icons.Docs]: '61720',
  [Icons.Dots]: '61721',
  [Icons.Download]: '61722',
  [Icons.Edit]: '61723',
  [Icons.EllipsisVertical]: '61724',
  [Icons.Ellipsis]: '61725',
  [Icons.EuroSignSolid]: '61726',
  [Icons.ExclamationTriangle]: '61727',
  [Icons.Exclamation]: '61728',
  [Icons.Expand]: '61729',
  [Icons.EyeClose]: '61730',
  [Icons.Eye]: '61731',
  [Icons.FileGenerate]: '61732',
  [Icons.File]: '61733',
  [Icons.Filters]: '61734',
  [Icons.Info]: '61735',
  [Icons.Link]: '61736',
  [Icons.ListCheckSolid]: '61737',
  [Icons.ListDark]: '61738',
  [Icons.Lock]: '61739',
  [Icons.Log]: '61740',
  [Icons.Logout]: '61741',
  [Icons.ModelIcon]: '61742',
  [Icons.Open]: '61743',
  [Icons.Pin]: '61744',
  [Icons.QuestionMark]: '61745',
  [Icons.Question]: '61746',
  [Icons.Recreate]: '61747',
  [Icons.RiskIcon]: '61748',
  [Icons.Scales]: '61749',
  [Icons.SearchFileIcon]: '61750',
  [Icons.Settings]: '61751',
  [Icons.SidebarRightIcon]: '61752',
  [Icons.Sparkles]: '61753',
  [Icons.Trendlines]: '61754',
  [Icons.TriangleExclamation]: '61755',
  [Icons.UploadImport]: '61756',
  [Icons.Upload]: '61757',
  [Icons.UsecaseIcon]: '61758',
  [Icons.UserSolid]: '61759',
  [Icons.ViewTable]: '61760',
  [Icons.ViewTags]: '61761',
  [Icons.Wallet]: '61762',
  [Icons.Xicon]: '61763',
};
